export default __webpack_public_path__ + "static/contact-9aa43a4a298abe2c237601930f11e97e.jpg";